//#region Mentions
/** Classname for at mention placeholder element, used when picker is open and user can enter text into this element to filter the picker results */ export const AtMentionPlaceholderClassName = "at-mention-placeholder";
/** Classname for rendered at mention item element */ export const AtMentionItemClassName = "at-mention-item";
/** Classname for rendered at mention that mentions the current user */ export const AtMentionMeItemClassName = "at-mention-me-item";
/** ID for the AtMentionPicker list element */ export const AtMentionPickerListId = "at-mention-picker-list";
/** Schema identifier for person mentions */ export const PersonMentionSchema = "https://schema.skype.com/Mention/Person";
/** Schema identifier for app mentions */ export const AppMentionSchema = "https://schema.skype.com/Mention/App";
// Note: Do not persist attributes with "data-" prefix because IC3 will sanitize it.
/** Attribute name for mention object ID */ export const MentionObjectIdAttribute = "mention-obj-id";
/** Attribute name for mention item type */ export const MentionItemTypeAttribute = "itemtype";
/** Attribute name for mention item index */ export const MentionItemIndexAttribute = "itemid";
/** Specific attributes allowed for sanitization when serializing */ export const AllowedChatDataAttributesForSerialize = [
    MentionObjectIdAttribute,
    MentionItemTypeAttribute,
    MentionItemIndexAttribute
];
/** Specific attributes allowed for sanitization when deserializing */ export const AllowedChatDataAttributesForDeserialize = [
    ...AllowedChatDataAttributesForSerialize
]; //#endregion
